var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	24326: {
		fallback: () => (__webpack_require__.e(805).then(() => (() => (__webpack_require__(90805))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "redux",

	},
	76790: {
		fallback: () => (__webpack_require__.e(1979).then(() => (() => (__webpack_require__(11979))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	94936: {
		fallback: () => (__webpack_require__.e(2909).then(() => (() => (__webpack_require__(22909))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.6.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "use-sync-external-store/shim",

	},
	51229: {
		fallback: () => (Promise.all([__webpack_require__.e(7435), __webpack_require__.e(9647), __webpack_require__.e(6677), __webpack_require__.e(0), __webpack_require__.e(9810)]).then(() => (() => (__webpack_require__(83234))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "dhl-shipment-utils",

	},
	453: {
		fallback: () => (Promise.all([__webpack_require__.e(3964), __webpack_require__.e(3971)]).then(() => (() => (__webpack_require__(23971))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "dhl-shipment-ui-components",

	},
	83964: {
		fallback: () => (__webpack_require__.e(5327).then(() => (() => (__webpack_require__(77708))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	10000: {
		fallback: () => (__webpack_require__.e(5729).then(() => (() => (__webpack_require__(95729))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.99.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@tanstack/react-query",

	},
	3925: {
		fallback: () => (__webpack_require__.e(2879).then(() => (() => (__webpack_require__(52879))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^9.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-redux",

	},
	63417: {
		fallback: () => (Promise.all([__webpack_require__.e(7494), __webpack_require__.e(4326)]).then(() => (() => (__webpack_require__(27494))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.11.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@reduxjs/toolkit",

	},
	28647: {
		fallback: () => (__webpack_require__.e(5292).then(() => (() => (__webpack_require__(35292))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "dhl-address-widget",

	},
	60431: {
		fallback: () => (Promise.all([__webpack_require__.e(2755), __webpack_require__.e(4825)]).then(() => (() => (__webpack_require__(37206))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.14.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router",

	},
	65591: {
		fallback: () => (__webpack_require__.e(5914).then(() => (() => (__webpack_require__(93050))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "dhl-ai-description",

	},
	93361: {
		fallback: () => (__webpack_require__.e(5561).then(() => (() => (__webpack_require__(85561))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "dhl-gspl",

	},
	9542: {
		fallback: () => (Promise.all([__webpack_require__.e(2755), __webpack_require__.e(3034), __webpack_require__.e(3964), __webpack_require__.e(1918)]).then(() => (() => (__webpack_require__(63034))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.14.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	51918: {
		fallback: () => (__webpack_require__.e(1968).then(() => (() => (__webpack_require__(37206))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.14.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router",

	},
	60855: {
		fallback: () => (Promise.all([__webpack_require__.e(7435), __webpack_require__.e(9647), __webpack_require__.e(1129), __webpack_require__.e(3964), __webpack_require__.e(1652)]).then(() => (() => (__webpack_require__(53232))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "dhl-shipment-libs",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"0": [
		10000
	],
	"453": [
		453
	],
	"1229": [
		51229
	],
	"1652": [
		28647,
		60431,
		65591,
		93361
	],
	"1918": [
		51918
	],
	"2555": [
		94936
	],
	"3964": [
		83964
	],
	"4326": [
		24326
	],
	"4936": [
		76790,
		9542,
		51229,
		60855,
		10000
	],
	"5005": [
		3925,
		63417
	],
	"6790": [
		76790
	],
	"9542": [
		9542
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}